export enum HopiItemChoiceType {
  CARDNO = 'CARDNO',
  TOKEN = 'TOKEN',
}
